import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { BidRequestStatus } from "interfaces";
import { CustomAlert } from "ui/CustomAlert";
import { parseTextMessage } from "./helpers";
import { Flex } from "antd";

export const ActionRequestNotifier = observer(({ testStatus }: { testStatus?: BidRequestStatus }) => {
  const { bidCard } = useStores();

  const alertMessage = bidCard.dmnTooltipsData || [];

  if (alertMessage.length === 0) {
    return null;
  }

  return (
    <>
      {alertMessage.length > 0 && (
        <Flex gap="small" wrap={true}>
          {alertMessage.map(({ message }, key) => (
            <CustomAlert
              message={parseTextMessage({ text: message, network: bidCard.bid?.network })}
              showIcon
              key={key}
              variant="purple"
              style={{ fontSize: "12px" }}
            />
          ))}
        </Flex>
      )}
    </>
  );
});
